export interface Symptom {
  title: string;
  body: string;
}

export function SymptomGrid({
  items,
  onDark = false,
  variant = "cards",
}: {
  items: readonly Symptom[];
  onDark?: boolean;
  variant?: "cards" | "list";
}) {
  if (variant === "list") {
    return (
      <ul className="border-t border-border/60">
        {items.map((item, i) => (
          <li key={item.title} className="border-b border-border/60 py-6 md:py-7">
            <div className="flex items-baseline gap-4">
              <span
                className="text-sm font-semibold tabular-nums text-[#693D94] md:text-base"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3
                className={`text-xl font-bold leading-snug md:text-2xl ${
                  onDark ? "text-white" : "text-[#111111]"
                }`}
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {item.title}
              </h3>
            </div>
            <p
              className={`mt-3 max-w-2xl pl-[calc(0.875rem+1rem)] text-base leading-relaxed md:pl-[calc(1rem+1rem)] ${
                onDark ? "text-white/75" : "text-muted-foreground"
              }`}
            >
              {item.body}
            </p>
          </li>
        ))}
      </ul>
    );
  }

  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {items.map((item) => (
        <article
          key={item.title}
          className={
            onDark
              ? "group relative overflow-hidden rounded-2xl border border-white/15 bg-white/10 p-7 backdrop-blur-sm transition-all hover:-translate-y-1 hover:border-white/30 hover:bg-white/15"
              : "group relative overflow-hidden rounded-2xl border border-border/60 bg-background p-7 transition-all hover:-translate-y-1 hover:border-primary/30 hover:shadow-[0_10px_30px_-8px_rgba(0,0,0,0.15)]"
          }
        >
          <h3 className={`font-display text-xl leading-snug ${onDark ? "text-white" : "text-ink"}`}>
            {item.title}
          </h3>
          <p
            className={`mt-3 text-sm leading-relaxed ${
              onDark ? "text-white/75" : "text-muted-foreground"
            }`}
          >
            {item.body}
          </p>
        </article>
      ))}
    </div>
  );
}
